__turbopack_context__.v({
  "completed": "RepairStatusStepper-module-scss-module__kQUXPq__completed",
  "current": "RepairStatusStepper-module-scss-module__kQUXPq__current",
  "date": "RepairStatusStepper-module-scss-module__kQUXPq__date",
  "label": "RepairStatusStepper-module-scss-module__kQUXPq__label",
  "node": "RepairStatusStepper-module-scss-module__kQUXPq__node",
  "step": "RepairStatusStepper-module-scss-module__kQUXPq__step",
  "steps": "RepairStatusStepper-module-scss-module__kQUXPq__steps",
});
